module.exports = __webpack_public_path__ + "static/greybunny1-5fd613e4d7a30ad18c87b5bf7fda36e0.png";